import { useState } from 'react';
import { Provider } from 'react-redux';
import './App.css';
import Navbar from './components/Navbar';
import CartPage from './pages/CartPage';
import HomePage from './pages/HomePage';
import store from './redux/store';

function App() {
  const [home, setHome] = useState(true);
  return (
    <Provider store={store}>
      <Navbar setHome={setHome} />
      {home ? <HomePage /> : <CartPage />}
    </Provider>
  );
}

export default App;
